import { IActionFn } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';

// 查询灯光文件列表
export const queryIesList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setIesList', { ...state.list, loading: true });
    // const res = await $http.post('/model/type/item/luminor/ies/list', payload);
    const res = await $http.post('/v1/asset/item/luminor/ies/list', payload);
    commit('setIesList', { data: res });
  } catch (e) {
    commit('setIesList', { data: [] });
  }
};

// 新增灯光配置(上传)
export const addMatIes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/model/type/item/luminor/ies/upload', payload);
    await $http.post('/v1/asset/item/luminor/ies/upload', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑灯光配置(上传)
export const editMatIes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/model/type/item/luminor/ies/modify', payload);
    await $http.post('/v1/asset/item/luminor/ies/modify', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 编辑灯光文件名
export const editMatIesName: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/model/type/item/luminor/ies/modify/filename', payload);
    await $http.post('/v1/asset/item/luminor/ies/modify/filename', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 删除灯光配置
export const deleteMatIes: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/luminor/ies/delete', payload);
    await $http.post('/v1/asset/item/luminor/ies/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
